export const UPDATE_LATEST_KITS = "UPDATE_LATEST_KITS";
export const UPDATE_LATESTSOLD_KITS = "UPDATE_LATESTSOLD_KITS";
